import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'
import SmartNavigator from '../../generic/SmartNavigator'
import ClusterSettings from './ClusterSettings'
import HistoricSyncRequests from './HistoricSyncRequests'
import PendingSyncRequests from './PendingSyncRequests'

const MainClusterRequests = (props) => {
  const { t_ } = useSmartTranslation()
  const activePath = props.activePath
  const componentsInfo = [
    {
      title: t_('Pending sync requests'),
      component: <PendingSyncRequests />,
      to: '/cluster/pendingRequests',
      permissionCode: 'PENDING_SYNC_REQUESTS'
    },
    {
      title: t_('Historic sync requests'),
      component: <HistoricSyncRequests />,
      to: '/cluster/historicRequests',
      permissionCode: 'HISTORIC_SYNC_REQUESTS'
    },
    {
      title: t_('Cluster settings'),
      component: <ClusterSettings />,
      to: '/cluster/settings',
      permissionCode: 'CLUSTER_SETTINGS'
    }
  ]
  return (
    <div>
      <SmartNavigator componentsInfo={componentsInfo} selected={activePath} />
    </div>
  )
}

export default MainClusterRequests
